class Config {
  environment: string = '';
  environmentColor: string = '';
  identityUrl: string = '';
  identityRedirectUrl: string = '';
  title: string = '';
  homeText: string = '';
  rootMenuItem: string = '';
  identityIwaEnabled: boolean = false;
  skipLogin: boolean = false;
  hideSetParticipant: boolean = false;
  hideChangePassword: boolean = false;
  changePasswordRedirectUrl: string = '';
  backgroundImage: string = '';
  helpUrl: string = './help';

  constructor() {
    let request = new XMLHttpRequest();
    request.open("GET", "./config/config.json", false);
    request.send(null);
    let jsonObject = JSON.parse(request.responseText);

    this.environment = jsonObject.environment;
    this.environmentColor = jsonObject.environmentColor;
    this.backgroundImage = jsonObject.backgroundImage;
    this.identityUrl = jsonObject.identityUrl;
    this.identityRedirectUrl = jsonObject.identityRedirectUrl;
    this.title = jsonObject.title;
    this.homeText = jsonObject.homeText;
    this.rootMenuItem = jsonObject.rootMenuItem;
    this.identityIwaEnabled = jsonObject.identityIwaEnabled || true;
    this.skipLogin = jsonObject.skipLogin || false;
    this.hideSetParticipant = jsonObject.hideSetParticipant || false;
    this.hideChangePassword = jsonObject.hideChangePassword || false;
    this.changePasswordRedirectUrl = jsonObject.changePasswordRedirectUrl;
    this.helpUrl = jsonObject.helpUrl || './help';
  }
}

export default new Config();



// WEBPACK FOOTER //
// src/config.ts